<template>
  <div style="padding-bottom: 10px;">
      <div v-if="troubleList.length > 0">
        <div v-for="trouble in troubleList" :key="trouble.trouble_id"
             style="border: solid 1px #d7dade;margin: 0 20px 20px 20px;">
          <FrameForm :ref="'frameForm'+trouble.trouble_id" component-param="bu_batching" :init-data="trouble" :parent-data="trouble" v-if="trouble"/>
        </div>
      </div>
      <div v-else style="border: solid 1px #d7dade;margin: 0 20px 0 20px;">
        <FrameForm ref="frameForm" component-param="bu_batching" :parentData="parentData"/>
      </div>
  </div>
</template>

<script>

export default {
  name: "StationTroubleList",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      repairPlan: {},
      troubleList: [],
    }
  },
  computed: {
  },
  created() {
    this.getRepairPlanList ()
  },
  mounted() {
  },
  methods: {

    //获取物品维修方案
    async getRepairPlanList() {
      this.repairPlan = await this.$http('buItemService.getRepairPlanList', {item_id: this.parentData.id,})
      if (this.repairPlan){
        this.troubleList = this.repairPlan.trouble_list
      }
    },

  }
}
</script>

<style scoped lang="less">

.trouble-form{
  padding: 10px 0 0 0;
  width: 700px;
}

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}

.btn-row {
  padding: 5px 0;
}

.oqcSubmit-row {
  margin: 10px 0;
  padding-top: 0px;
  padding-left: 150px;
  //border-top: 1px solid #ddd;
}
</style>